import { Row, Col, Container, Form, Button } from "react-bootstrap";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import MaskedInput from 'react-text-mask';
import GoBackButton from "./GoBackButton";


const EditNoteBookComponent = ({
    updateNoteBookApiRequest,
    fetchNoteBook,
}) => {
    const [validated, setValidated] = useState(false);
    const [noteBook, setNoteBook] = useState([]);
    const [updateNoteBookResponseState, setUpdateNoteBookResponseState] =
        useState({
            message: "",
            error: "",
        });
    const { id } = useParams();
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;

        const formInputs = {
            companyName: form.companyName.value,
            contactPerson: form.contactPerson.value,
            contactEmail: form.contactEmail.value,
            createdDate: form.createdDate.value,
            notes: form.notes.value,
            onboard: form.onboard.value,
        };

        if (event.currentTarget.checkValidity() === true) {
            updateNoteBookApiRequest(id, formInputs)
                .then((data) => {
                    if (data.message === "Note Book Updated") {
                        navigate("/admin/salesNotes");
                    }
                })
                .catch((er) => {
                    setUpdateNoteBookResponseState({
                        error: er.response.data.message
                            ? er.response.data.message
                            : er.response.data,
                    });
                });
        }

        setValidated(true);
    };

    const checkKeyDown = (e) => {
        if (e.code === "Enter") e.preventDefault();
    };

    useEffect(() => {
        fetchNoteBook(id)
            .then((data) => {
                setNoteBook(data);
            })
            .catch((er) =>
                console.log(
                    er.response.data.message ? er.response.data.message : er.response.data
                )
            );
    }, [id]);

    // console.log(noteBook);

    return (
        <Container>
            <Row className="justify-content-md-center mt-5 content-container">
                <Col md={1}>
                    {/* <Link to="/admin/noteBooks" className="btn btn-info my-3">
                        Go Back
                    </Link> */}
                    <GoBackButton />
                </Col>
                <Col md={8}>
                    <h1>Edit Note Book</h1>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                        onKeyDown={(e) => checkKeyDown(e)}
                    >
                        <Form.Group className="mb-3" controlId="formBasicCompanyName">
                            <Form.Label>Company Name </Form.Label>
                            <Form.Control
                                name="companyName"
                                required
                                type="text"
                                defaultValue={noteBook.companyName}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicContactPerson">
                            <Form.Label>Contact Person </Form.Label>
                            <Form.Control
                                name="contactPerson"
                                required
                                type="text"
                                defaultValue={noteBook.contactPerson}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicContactEmail">
                            <Form.Label>Contact Email </Form.Label>
                            <Form.Control
                                name="contactEmail"
                                required
                                type="text"
                                defaultValue={noteBook.contactEmail}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicCreatedDate">
                            <Form.Label>Date </Form.Label>
                            <Form.Control
                                name="createdDate"
                                required
                                type="date"
                                defaultValue={noteBook.createdDate}
                            />
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicSignedBy"
                        >
                            <Form.Label>Rep.Name</Form.Label>
                            <Form.Control
                                name="signedBy"
                                required
                                disabled
                                type="text"
                                defaultValue={noteBook.signedBy ? noteBook.signedBy.split("@")[0].charAt(0).toUpperCase() + noteBook.signedBy.split("@")[0].slice(1) : ""}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicOnboard">
                            <Form.Label>Onboard</Form.Label>
                            <Form.Control
                                name="onboard"
                                required
                                type="text"
                                defaultValue={noteBook.onboard}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicNotes">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                                name="notes"
                                required as="textarea"
                                defaultValue={noteBook.notes}
                                rows={6} />
                        </Form.Group>

                        <Button className="mb-3" variant="primary" type="submit">
                            UPDATE
                        </Button>

                        <Link
                            to="/admin/salesNotes"
                            className="btn btn-secondary mb-3 ms-5"
                        >
                            Cancel
                        </Link>
                        <p></p>
                        {updateNoteBookResponseState.error ?? ""}
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default EditNoteBookComponent;
